import script from "./ServiceTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceTask.vue?vue&type=script&setup=true&lang=js"

import "./ServiceTask.vue?vue&type=style&index=0&id=7ade34e7&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ade34e7"]])

export default __exports__